import { render, staticRenderFns } from "./SystemParams.vue?vue&type=template&id=52a4ee1f&scoped=true&"
import script from "./SystemParams.vue?vue&type=script&lang=js&"
export * from "./SystemParams.vue?vue&type=script&lang=js&"
import style0 from "./SystemParams.vue?vue&type=style&index=0&id=52a4ee1f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a4ee1f",
  null
  
)

export default component.exports